module.exports = __webpack_public_path__ + "img/rocket.49d51f.svg";